import { render, staticRenderFns } from "./ClientWebshop.vue?vue&type=template&id=621eb918&"
import script from "./ClientWebshop.vue?vue&type=script&lang=js&"
export * from "./ClientWebshop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports